
import React from 'react'
import UserReport from '../../../components/report/userReport/UserReport'

const UserReportPage = () => {
    return (
        <>
            <UserReport />
        </>
    )
}

export default UserReportPage